import type { ReactNode } from 'react'

import type { SidebarLink } from './model'
import { SidebarNavLink } from './SidebarNavLink'

interface SidebarNavListProps {
  links?: SidebarLink[]
  /** Rows of another kind drawn after the links, such as a switch or a sub-menu. */
  children?: ReactNode
  'aria-labelledby'?: string
}

export function SidebarNavList({ links = [], children, ...props }: SidebarNavListProps) {
  return (
    <ul className="flex w-full min-w-0 flex-col gap-0.5 text-sm" {...props}>
      {links.map((link, index) => (
        <li key={link.url} className="relative">
          <SidebarNavLink link={link} index={index} />
        </li>
      ))}
      {children}
    </ul>
  )
}
